import React from 'react'

const RosterAccessDenied = () => {
  return (
    <div className="access-page">
      <div className="access-card">
        <div className="access-icon">
          🔒
        </div>

        <h1>Access Restricted</h1>

        <p>
          You don't have permission to access this feature.
          <br />
          Please contact your administrator if you believe this is a mistake.
        </p>
      </div>
    </div>
  );
}

export default RosterAccessDenied